import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  plans_title: {
    type: 'string',
  },
  plans_desc: {
    type: 'string',
  },
  plans_type: {
    type: 'string',
  },
  plans_city_code: {
    type: 'string',
  },
  per_tab: {
    type: 'boolean',
    default: true,
  },
  tab_to_show: {
    type: 'string',
    default: 'internet_default',
  },
  btnWhatsText: {
    type: 'string',
  },
  formAllServicesId: {
    type: 'string',
  },
  whatsLink: {
    type: 'string',
  },
  tab_order: {
    type: 'string',
  },
  plans_telefone: {
    type: 'string',
  },
  ...Common,
};